// utils/playAudioResponse.js
import { fetchAudio } from './fetchAudio';

export const speakText = async (text) => {
  try {
    const audioUrl = await fetchAudio(text);
    const audio = new Audio(audioUrl);
    audio.play();
    console.log('audio played..')
  } catch (error) {
    console.error('Audio playback failed:', error);
  }
};
